import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export default gql`
  mutation AcceptUserAgreements($input: AcceptUserAgreementsInput!) {
    acceptUserAgreements(input: $input) {
      ... on AcceptUserAgreementsSuccess {
        __typename
        accepted
      }
      ... on AcceptUserAgreementsError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;
